import { ConverterSet } from '../domain.js';
import { timestamp } from './timestamp.js';
import { fieldMask } from './field-mask.js';
import { bytes } from './bytes.js';
import { duration } from './duration.js';
import { float } from './float.js';

export const protobufConverters: ConverterSet[] = [
  timestamp,
  fieldMask,
  bytes,
  duration,
  float,
];
